import React from "react"
import { Modal } from "@mallardbay/lib-react-components"

import type {
    UserFieldsFragment,
    WishlistFieldsFragment,
} from "~graphql/generated/graphql"
import COPY from "~config/copy-constants"

import WishlistModalContent from "./wishlist-modal-content"

interface WishlistModalProps {
    readonly listingId: string
    readonly wishlists: WishlistFieldsFragment[]
    readonly user: UserFieldsFragment
    readonly isFetching?: boolean
    readonly isOpen: boolean
    readonly onClose: () => void
    readonly isCreating: boolean
    readonly setIsCreating: (value: boolean) => void
}

export default function WishlistModal({
    listingId,
    wishlists,
    user,
    isFetching,
    isOpen,
    onClose,
    isCreating,
    setIsCreating,
}: WishlistModalProps) {
    return (
        <Modal
            shouldAddPadding
            title={isCreating ? COPY.CREATE_WISHLIST : COPY.SAVE_TO_WISHLIST}
            onClose={() => {
                setIsCreating(false)
                if (!isCreating) onClose()
            }}
            isOpen={isOpen}
        >
            <WishlistModalContent
                isCreating={isCreating}
                setIsCreating={setIsCreating}
                listingId={listingId}
                onClose={onClose}
                user={user}
                wishlists={wishlists}
                isFetching={isFetching}
            />
        </Modal>
    )
}
